<template>
  <section class="s-before" aria-labelledby="insurance-before-title">
    <header class="s-before__header">
      <span class="s-before__shield"><img :src="shieldIcon" alt="" aria-hidden="true"></span>
      <h2 id="insurance-before-title" class="wd-title s-before__title">
        Antes de iniciar <br class="br-m"><span class="hl">tu reclamación</span>
      </h2>
    </header>

    <p class="s-before__lead">Para solicitar el uso de tu seguro es importante que:</p>

    <ul class="s-before__items">
      <li v-for="item in requirements" :key="item">
        <img :src="checkIcon" alt="" aria-hidden="true">
        <p class="wd-body">{{ item }}</p>
      </li>
    </ul>

    <p class="wd-body">
      La presentación de documentos no garantiza la procedencia del reclamo. <br class="br-d">Cada caso será evaluado por la aseguradora conforme a las condiciones de la póliza.
    </p>
  </section>
</template>

<script setup lang="ts">
import shieldIcon from '../../../assets/seguros-figma/shield.png'
import checkIcon from '../../../assets/seguros-figma/check-green.svg'

const requirements = [
  'Tu financiamiento se encuentre al corriente en sus pagos.',
  'La cobertura que deseas reclamar se encuentre contratada y vigente.',
  'La documentación de tu expediente esté completa.'
]
</script>

<style scoped>
.s-before {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-5);
  padding: var(--ds-space-5) var(--ds-space-6);
  box-sizing: border-box;
  background: #E7F0FC;
  border: 1px solid var(--ds-info-100);
  border-radius: 24px;
}

.s-before__header { display: flex; align-items: center; gap: var(--ds-space-3); }
.s-before__shield { display: flex; flex: 0 0 56px; align-items: center; justify-content: center; width: 56px; height: 56px; }
.s-before__shield img { width: 40px; height: 48px; object-fit: contain; }
.s-before .wd-title { color: var(--ds-text-body); }
.s-before .wd-title .hl { color: #6D59EA; }

.s-before__lead {
  margin: 0;
  color: var(--ds-purple-900);
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}

.s-before__items { display: flex; flex-direction: column; gap: var(--ds-space-5); margin: 0; padding: 0; list-style: none; }
.s-before__items li { display: flex; align-items: center; gap: var(--ds-space-3); min-height: 24px; }
.s-before__items img { flex: 0 0 24px; width: 21px; height: 16px; margin: 0 1.5px; }

@media (max-width: 1024px) {
  .s-before { padding: var(--ds-space-5); }
}

@media (max-width: 599px) {
  .s-before { padding: var(--ds-space-5) var(--ds-space-4); }
  .s-before__items img { align-self: center; }
}
</style>
